export default __webpack_public_path__ + "static/media/svcDelhi.8cc0e394.jpg";